/* ----- zip validation & dhl packstation --------------------------------------------------------------------------- */

/**
 * Hinweis: W�hlt man "weiter ohne Korrektur", so wird diese Einstellung auch beim Neuladen des Formulars,
 * z.B. wenn andere Felder noch fehlerhaft sind, gespeichert. Die ZIP-Pr�fung erfolgt erst dann wieder,
 * wenn die ZIP oder das Land ge�ndert werden.
 *
 */

function tblog (message) {
	if (typeof(console)!=='undefined' && console && console.log) {
		console.log(message);
	}
};

// ZIP-Pr�fung

$(function(){

	if (($('html#shop-address-combined').length || $('html#shop-address-manage').length || $('html#shop-deliv-address-manage').length)) { // && (typeof(euramin_testmode)!=='undefined') && euramin_testmode

		// from template:
		// euramin_shop_language = string, e.g. 'FRA'
		// euramin_testmode = boolean
		// euramin_otp1 = string, otp1

		var country_text = {
			AUT: {
				DEU: '&Ouml;sterreich',
				NLD: 'Oostenrijk',
				FRA: 'Autriche',
				ITA: 'Austria',
				GBR: 'Austria',
				ESP: 'Austria'
			},
			BEL: {
				DEU: 'Belgien',
				NLD: 'Belgi&euml;',
				FRA: 'Belgique',
				ITA: 'Belgio',
				GBR: 'Belgium',
				ESP: 'B&eacute;lgica'
			},
			CHE: {
				DEU: 'Schweiz',
				NLD: 'Zwitserland',
				FRA: 'Suisse',
				ITA: 'Svizzera',
				GBR: 'Switzerland',
				ESP: 'Suiza'
			},
			DEU: {
				DEU: 'Deutschland',
				NLD: 'Duitsland',
				FRA: 'Allemagne',
				ITA: 'Germania',
				GBR: 'Germany',
				ESP: 'Alemania'
			},
			ESP: {
				DEU: 'Spanien',
				NLD: 'Spanje',
				FRA: 'Espagne',
				ITA: 'Spagna',
				GBR: 'Spain',
				ESP: 'Espa&ntilde;a'
			},
			FRA: {
				DEU: 'Frankreich',
				NLD: 'Frankrijk',
				FRA: 'France',
				ITA: 'Francia',
				GBR: 'France',
				ESP: 'Francia'
			},
			ITA: {
				DEU: 'Italien',
				NLD: 'Itali&euml;',
				FRA: 'Italie',
				ITA: 'Italia',
				GBR: 'Italy',
				ESP: 'Italia'
			},
			NLD: {
				DEU: 'Niederlande',
				NLD: 'Nederland',
				FRA: 'Pays-Bas',
				ITA: 'Paesi Bassi',
				GBR: 'The Netherlands',
				ESP: 'Pa&iacute;ses Bajos'
			}
		};

		var messages = {
			zip_invalid_in_selected_country: {
				DEU: 'Die eingegebene Postleitzahl ist im gew&auml;hlten Land {{selectedCountry}} nicht g&uuml;ltig.<br>Bitte &uuml;berpr&uuml;fen Sie Ihre Eingaben.',
				NLD: 'De opgegeven postcode is in het geselecteerde land {{selectedCountry}} niet geldig.<br>Controleer uw gegevens.',
				FRA: 'Le code postal n&rsquo;est pas valide dans le pays pour lequel vous avez opt&eacute; ({{selectedCountry}}).<br>Veuillez SVP v&eacute;rifier vos donn&eacute;es.',
				ITA: 'Il codice di avviamento postale inserito non &egrave; valido per il paese selezionato {{selectedCountry}}.<br>Controllare il dato inserito.',
				GBR: 'The entered Post Code is not valid in {{selectedCountry}}.<br>Please check your entry.',
				ESP: 'El c&oacute;digo postal indicado no es v&aacute;lido en el pa&iacute;s seleccionado {{selectedCountry}}.<br>Por favor, compruebe sus datos.'
			},
			zip_mismatch_france_metropolitaine: {
				FRA: 'Le code postal que vous avez indiqu&eacute; n&rsquo;est pas valide en France m&eacute;tropolitaine.<br>Veuillez SVP v&eacute;rifier vos donn&eacute;es et au cas &eacute;ch&eacute;ant choisir une autre destination (p. ex. Guadeloupe, Martinique, R&eacute;union, etc.)'
			}
		};

		var rules = [
			{
				subshop: ['*'],
				country: ['DEU','ESP','FRA','ITA'],
				rule: new RegExp('^[0-9]{5}$'),
				message: messages['zip_invalid_in_selected_country']
			},
			{
				subshop: ['*'],
				country: ['AUT','CHE','BEL'],
				rule: new RegExp('^[0-9]{4}$'),
				message: messages['zip_invalid_in_selected_country']
			},
			{
				subshop: ['*'],
				country: ['NLD'],
				rule: new RegExp('^.+?[^a-z]+?[a-z]{2}$', 'i'), // PLZ endet mindestens mit 1 Buchstabe und 2 Ziffern, z.B. 1234ab, x1ab; (offiziell: 4 Ziffern und 2 Buchstaben)
				message: messages['zip_invalid_in_selected_country']
			},
			{
				subshop: ['FRA'],
				country: ['FRA'],
				rule: new RegExp('^(?!97)[0-9]{5}$'), // PLZ beginnt nicht mit 97 und hat exakt 5 Ziffern
				message: messages['zip_mismatch_france_metropolitaine']
			}
		];

		var euramin_form_validate_billing_zip = true,
			euramin_form_validate_delivery_zip = true,
			euramin_form_validate_billing_zip_false_val = 'euramin_form_validate_billing_zip_false',
			euramin_form_validate_delivery_zip_false_val = 'euramin_form_validate_delivery_zip_false',
			form = $('form#addr_form'),
			form_input_error_class = 'form-control-error';


		function getFlags(fieldname) {
			return form.find('input[name="' + fieldname + '"]').val() || '';
		};

		function setFlags(fieldname, value) {
			var field = form.find('input[name="' + fieldname + '"]');
			if (!field.length) {
				form.append('<input type="hidden" name="' + fieldname + '" value="' + value + '" />');
			} else {
				field.val(value);
			}
			return value;
		};

		var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );

		function stripAndCollapse(value) {
			var tokens = value.match(rnothtmlwhite) || [];
			return tokens.join(' ');
		};

		// adds flag (text) to otp1 field. supports multiple flags at once (syntax like css classes).
		function addFlag(value) {
			var flags, cur, curValue, flag, j, finalValue;

			if (typeof value === "string" && value) {
				flags = value.match(rnothtmlwhite) || [];

				curValue = getFlags('otp1');
				cur = " " + stripAndCollapse(curValue) + " ";

				if (cur) {
					j = 0;
					while (( flag = flags[j++] )) {
						if (cur.indexOf(" " + flag + " ") < 0) {
							cur += flag + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse(cur);
					if (curValue !== finalValue) {
						setFlags('otp1', finalValue);
					}
				}
			}
		};

		// removes flag (text) from otp1 field. supports multiple flags at once (syntax like css classes).
		function removeFlag(value) {
			var flags, elem, cur, curValue, flag, j, finalValue;
			if (!arguments.length) {
				return setFlags('otp1', '');
			}
			if (typeof value === "string" && value) {
				flags = value.match(rnothtmlwhite) || [];
				curValue = getFlags('otp1');
				cur = " " + stripAndCollapse(curValue) + " ";
				if (cur) {
					j = 0;
					while (( flag = flags[j++] )) {
						// Remove *all* instances
						while (cur.indexOf(" " + flag + " ") > -1) {
							cur = cur.replace(" " + flag + " ", " ");
						}
					}
					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse(cur);
					if (curValue !== finalValue) {
						setFlags('otp1', finalValue);
					}
				}
			}
		};

		// checks if flag is set in otp1 field. supports multiple flags at once (syntax like css classes).
		function hasFlag(value) {
			var flag;
			flag = " " + value + " ";
			if (( " " + stripAndCollapse(getFlags('otp1')) + " " ).indexOf(flag) > -1) {
				return true;
			}
		};

		// higher level funtions for enabled/disabled-flag handling
		function enableZipValidation(address_type) {
			if (typeof address_type === 'string' && address_type) {
				if (address_type.indexOf('billing') > -1) {
					removeFlag(euramin_form_validate_billing_zip_false_val);
					euramin_form_validate_billing_zip = true;
				} else {
					removeFlag(euramin_form_validate_delivery_zip_false_val);
					euramin_form_validate_delivery_zip = true;
				}
			}
		};

		function disableZipValidation(address_type) {
			if (typeof address_type === 'string' && address_type) {
				if (address_type.indexOf('billing') > -1) {
					addFlag(euramin_form_validate_billing_zip_false_val);
					euramin_form_validate_billing_zip = false;
				} else {
					addFlag(euramin_form_validate_delivery_zip_false_val);
					euramin_form_validate_delivery_zip = false;
				}
			}
		};


		// validates zip value according to current subshop, selected country and defined rules
		// returns result object { zipIsValid: true|false, message: '' }
		// result['zipIsValid'] == false, if zip is invalid, message = error message string
		// result['zipIsValid'] == true if zip was not checked (when it's empty) or if the check was valid, message empty
		function checkZIP(country, zip) {
			// tblog('checking zip new');
			var result = { zipIsValid: true, message: '' };
			if ((typeof(country) === 'string') && (typeof(zip) === 'string') && (zip !== '')) {
				// iterate through rule definitions
				$.each( rules, function( k, rule ) {
					// check if rule applies to current subshop (=euramin_shop_language)
					if ( $.inArray( '*', rule['subshop'] ) > -1 || $.inArray( euramin_shop_language, rule['subshop'] ) > -1 ) { // euramin_shop_language = e.g. 'FRA' (from template)
						// check if rule applies to current selected country
						if ( $.inArray( country, rule['country'] ) > -1 ) {
							if ( rule['rule'] instanceof RegExp ) {
								result['zipIsValid'] = rule['rule'].test(zip);
							} else {
								result['zipIsValid'] = true; // rule was invalid (no regex), so zip has to be classified as valid
							}
							if (result['zipIsValid']===false) {
								// apply and postprocess message
								result['message'] = rule['message'][euramin_shop_language];
								if ( typeof( result['message']==='string' ) ) {
									result['message'] = result['message'].replace('{{selectedCountry}}', country_text[country][euramin_shop_language]); // apply name of selected country in subshop language
								} else {
									result['message'] = '';
								}
							}
						}
					}
					return result['zipIsValid'];
				});
			}
			return result;
		};

		// result_zip_field = jquery object of zip input field
		// country_code = 3 letter iso code
		function createDialogZIP(result_zip_field, country_code, message) {
			var	text_header = {
					billing_address: {
						DEU: 'Ihre Rechnungsadresse',
						NLD: 'Uw rekeningadres',
						FRA: 'Votre adresse de facturation',
						ITA: 'Indirizzo di fatturazione',
						GBR: 'Billing address',
						ESP: 'Direcci&oacute;n de facturaci&oacute;n'
					},
					delivery_address: {
						DEU: 'Ihre Lieferadresse',
						NLD: 'Uw bezorgadres',
						FRA: 'Votre adresse de livraison',
						ITA: 'Indirizzo di consegna',
						GBR: 'Delivery address',
						ESP: 'Direcci&oacute;n de entrega'
					}
				},
				text_button_cancel = {
					DEU: 'Weiter ohne Korrektur',
					NLD: 'Doorgaan zonder correctie',
					FRA: 'Je continue sans correction',
					ITA: 'Continua senza correzioni',
					GBR: 'Continue without corrections',
					ESP: 'Seguir sin cambios'
				},
				text_button_ok = {
					DEU: 'Postleitzahl korrigieren',
					NLD: 'Postcode corrigeren',
					FRA: 'Je corrige le code postal',
					ITA: 'Correggi il CAP',
					GBR: 'Correct &lsquo;Post Code&rsquo;',
					ESP: 'Cambiar c&oacute;digo postal'
				},
				dialog_content = {
					header: ((result_zip_field.parents('.form-fields-group.billing_address').length) ? text_header['billing_address'][euramin_shop_language] : text_header['delivery_address'][euramin_shop_language]),
					content: '<p>' + message + '</p>',
					button_cancel: text_button_cancel[euramin_shop_language],
					button_ok: text_button_ok[euramin_shop_language]
				},
				dialog_template = $('#euramin_form_validation_notice_template').html(),
				dialog,
				$modal,
				dialog_wrapper,
				layer_id = 'euramin_form_validation_notice_layer',
				$layer = $('#' + layer_id),
				layer = ($layer.length) ? false : $('<div></div>').attr('id', layer_id).hide().appendTo('body'),
				_;

			if (layer === false) {
				// das ist nur dann der Fall, wenn es jemand schafft, ein form-submit auszul�sen, w�hrend der Layer offen ist.
				return false; // return if layer already existed before
			}

			Mustache.parse(dialog_template);
			dialog = Mustache.render(dialog_template, dialog_content);
			//layer.html(dialog).hide().fadeIn('fast');
				layer.html(dialog).show();
				$modal = layer.find('.euramin_form_validation_notice_dialog');
				$modal.modal('show');
			dialog_wrapper = layer.find('.euramin_form_validation_notice_wrapper');

			// button: user would not correct ones wrong input
			$('.euramin_form_validation_notice_button_cancel').click(function (e) {
				// e.stopPropagation();
				// trigger custom event when form submit was cancelled
				form.trigger('customEventOnFormSubmitCancelled');

				var address_type = ( result_zip_field.parents('.form-fields-group.billing_address').length ) ? 'billing' : 'delivery';
				disableZipValidation(address_type);
				result_zip_field.removeClass(form_input_error_class).focus();

				$modal.modal('hide');
				$modal.on('hidden.bs.modal', function () {
					// result_zip_field.focus().setCursorPosition(-1); // warum geht nicht einfach focus(), so wie im alten shop???

				// layer.fadeOut('fast', function () {
					// $(this).hide().remove();

					// trigger form submit again, but only if - when a delivery address is currently enabled - the opposite address_type's zip field is valid - when zip field validation for this field is enabled
					// check if delivery address form fields are visible / editable
					if ($('input[name="name_select_radio_deliv"]:checked').val() === 'inputdeliv') {
						var
							billing_address = $('.form-fields-group.billing_address'),
							billing_zip_field = billing_address.find('input.input_zip'),
							billing_zip = $.trim(billing_zip_field.val()),

							delivery_address = $('.form-fields-group.delivery_address'),
							delivery_zip_field = delivery_address.find('input.input_zip'),
							delivery_zip = $.trim(delivery_zip_field.val()),

							billing_country_field = billing_address.find('select.select_country'),
							billing_country = billing_country_field.val(),

							delivery_country_field = delivery_address.find('select.select_country'),
							delivery_country = delivery_country_field.val();

						// extract 3-letter iso codes from country strings (e.g. Deutschland, DEU -> DEU)
						billing_country = billing_country.substr(billing_country.length - 3);
						delivery_country = delivery_country.substr(delivery_country.length - 3);

						// check if opposite zip field's validation is enabled and if opposite zip field is valid
						var reSubmitForm = false;
						if (address_type === 'billing') {
							// reSubmitForm = !euramin_form_validate_delivery_zip || checkZIP(delivery_country, delivery_zip); // refactored version
							if (euramin_form_validate_delivery_zip) {
								var zipResult = checkZIP(delivery_country, delivery_zip);
								if ( zipResult['zipIsValid'] ) {
									reSubmitForm = true;
								}
							} else {
								reSubmitForm = true;
							}
						} else {
							if (euramin_form_validate_billing_zip) {
								var zipResult = checkZIP(billing_country, billing_zip);
								if ( zipResult['zipIsValid'] ) {
									reSubmitForm = true;
								}
							} else {
								reSubmitForm = true;
							}
						}
						if (reSubmitForm) {
							$('input.form_btn_addr_save').click();
						}
					} else {
						// in every other case -> resubmit form (because we're just checking the billing address
						$('input.form_btn_addr_save').click();
					}
			//	});
					$(this).data('bs.modal', null);
					layer.hide().remove();

				});

			});

			// button: user will correct ones wrong input
			$('.euramin_form_validation_notice_button_ok').click(function (e) {
				// e.stopPropagation();
				// trigger custom event when form submit was cancelled // ???
				form.trigger('customEventOnFormSubmitCancelled');
				$modal.modal('hide');
				$modal.on('hidden.bs.modal', function () {
					$(this).data('bs.modal', null);
					layer.hide().remove();
					// result_zip_field.focus(); //.setCursorPosition(-1); // warum geht nicht einfach focus(), so wie im alten shop???
					// setTimeout(function(){result_zip_field.focus();}, 5000);
					result_zip_field.selectRange(0, 999);
					$(window).scrollTo(result_zip_field, { offset: -75, duration: 500 });
				});

				/*
				layer.fadeOut('fast', function () {
					$(this).hide().remove();
				});
				*/

			});

			/*
			function reposition() {
				// reposition dialog
				layer //.find('.euramin_form_validation_notice_dialog')
					.position({
						my: 'center',
						at: 'center',
						of: window
					});
			};
			reposition();
			*/

			/*
			layer.click(function (e) {
				result_zip_field.focus();
				layer.fadeOut('fast', function () {
					$(this).hide().remove();
				});
			});
			*/

			/*
			dialog_wrapper.click(function (e) {
				e.stopPropagation();
				e.preventDefault();
			});
			*/

			/*
			$(window).resize(reposition).scroll(reposition);
			*/

		};


		// initialize: parse and store flag(s) from previous page in semi global variable
		if (typeof( euramin_otp1 ) === 'string' && euramin_otp1) {
			if (( ' ' + stripAndCollapse(euramin_otp1) + ' ' ).indexOf(' ' + euramin_form_validate_billing_zip_false_val + ' ') > -1) {
				disableZipValidation('billing');
			}
			if (( ' ' + stripAndCollapse(euramin_otp1) + ' ' ).indexOf(' ' + euramin_form_validate_delivery_zip_false_val + ' ') > -1) {
				disableZipValidation('delivery');
			}
		}


		form.submit(function (e) {

			// check if either validating the billing or the delivery zip is allowed
			if (euramin_form_validate_billing_zip || euramin_form_validate_delivery_zip) {

				var
					billing_address = $('.form-fields-group.billing_address'),                       					// $('.form-fields-group.billing_address').find('select.select_country').val().substr( $('.form-fields-group.billing_address').find('select.select_country').val().length-3)
					billing_zip_field = billing_address.find('input.input_zip'),
					billing_zip = $.trim(billing_zip_field.val()),

					delivery_address = $('.form-fields-group.delivery_address'),
					delivery_zip_field = delivery_address.find('input.input_zip'),
					delivery_zip = $.trim(delivery_zip_field.val()),

					billing_country_field = billing_address.find('select.select_country'),
					billing_country = billing_country_field.val(),
					billing_country = (typeof(billing_country) !== 'undefined') ? billing_country.substr(billing_country.length - 3) : undefined, // 3-stelliger ISO-Code

					delivery_country_field = delivery_address.find('select.select_country'),
					delivery_country,

					result = false;

				// take dhl packstation into account, where there is no country field
				if (!delivery_country_field.length) {
					delivery_country = 'DEU';
				} else {
					delivery_country = delivery_country_field.val();
					delivery_country = delivery_country.substr(delivery_country.length - 3); // 3-stelliger ISO-Code
				}

				// reset zip fields' error class
				$(billing_zip_field, delivery_zip_field).removeClass(form_input_error_class);

				// check zip fields
				if (euramin_form_validate_billing_zip) {
					var zipResult = checkZIP(billing_country, billing_zip);
					if ( zipResult['zipIsValid'] ) {
						result = true;
					} else {
						billing_zip_field.addClass(form_input_error_class);
						createDialogZIP( billing_zip_field, billing_country, zipResult['message'] );
						return false;
					}
				} else {
					result = true;
				}
				// check delivery address only if 1.) billing address was valid 2.) delivery fields are visible 3.) validation is currently allowed
				if (result && euramin_form_validate_delivery_zip && delivery_zip_field.is(':visible')) {
					var zipResult = checkZIP(delivery_country, delivery_zip)
					if ( !zipResult['zipIsValid'] ) {
						delivery_zip_field.addClass(form_input_error_class);
						createDialogZIP( delivery_zip_field, delivery_country, zipResult['message'] );
						return false;
					}
				}

			}

		});

		// reactivate validation when user edits one of the zip fields
		form.find('input.input_zip, select.select_country').change(function () {
			if ($(this).parents('.form-fields-group.billing_address').length) {
				enableZipValidation('billing');
			} else {
				enableZipValidation('delivery');
			}
		});

	}

});


